import { render, staticRenderFns } from "./sortable-table-head.vue?vue&type=template&id=b265c522&scoped=true&"
import script from "./sortable-table-head.vue?vue&type=script&lang=js&"
export * from "./sortable-table-head.vue?vue&type=script&lang=js&"
import style0 from "./sortable-table-head.vue?vue&type=style&index=0&id=b265c522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b265c522",
  null
  
)

export default component.exports